module.exports = __webpack_public_path__ + "static/media/mobile.a64f1ae9.svg";